<mat-form-field [class.price-error]="hasError">
  <input matInput #innerInput [placeholder]="placeholderText" [ngModel]="price" (blur)="onBlur(innerInput.value)">
  <mat-hint [class.price-error]="hasError" *ngIf="hasError">
    {{ null | invalid_errormsg }}
  </mat-hint>
</mat-form-field>
